/* istanbul ignore file */

import { helpers } from "vuelidate/lib/validators";
import moment from "moment";

const validTime = helpers.regex("time", /^[0-9][0-9]:[0-5][0-9](:[0-5][0-9])?$/);

const validDate = dateFormatString =>
	helpers.withParams({ type: "validDate", dateFormatString }, value => {
		let required = !helpers.req(value);
		let validDate = moment(value, dateFormatString || "MM/DD/YYYY").isValid();
		return required || validDate;
	});

const maxDate = date => {
	const maxDate = moment(date);

	return helpers.withParams({ type: "maxDate", max: maxDate }, value => {
		let required = !helpers.req(value);
		let validDate = moment(value) <= maxDate;
		return required || validDate;
	});
};

const minDate = date => {
	const minDate = moment(date);

	return helpers.withParams({ type: "minDate", min: minDate }, value => {
		let required = !helpers.req(value);
		let validDate = moment(value) >= minDate;
		return required || validDate;
	});
};

export { validTime, validDate, maxDate, minDate };
